/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeSecretsListComputeSecrets } from "../../funcs/computeSecretsListComputeSecrets.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListComputeSecretsRequest$inboundSchema,
};

export const tool$computeSecretsListComputeSecrets: ToolDefinition<
  typeof args
> = {
  name: "compute-secrets-list-compute-secrets",
  description: `List secrets`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeSecretsListComputeSecrets(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
